module.exports = __webpack_public_path__ + "img/spread-it.303e0b06.png";